import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IClientInfo } from 'src/app/model/client-info.interface';
import { SharedDataService } from 'src/app/service/shared-data.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  imprintUri = '';
  tosUri = '';
  policyUri = '';
  requestId: any;

  constructor(private dataService: SharedDataService, private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.dataService._getClientInfo().subscribe((data: IClientInfo) => {
      if (data) {
        if(data.imprint_uri){
          this.imprintUri = data.imprint_uri;
        }
        if(data.tos_uri){
          this.tosUri = data.tos_uri ;
        }
        if(data.policy_uri){
          this.policyUri = data.policy_uri ;
        }
      }
    });
    this.route.queryParams.subscribe((params) => {
      this.requestId = params.requestId || null;
    });
  }
}
